import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import { Link } from 'react-router';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../config/constants';
import { SEO } from '../components/SEO';

export const Help = () => {
  const { t } = useTranslation('help');
  
  const faqs = [
    {
      question: t('faqs.whatIsScribelate.question'),
      answer: t('faqs.whatIsScribelate.answer'),
    },
    {
      question: t('faqs.supportedLanguages.question'),
      answer: t('faqs.supportedLanguages.answer'),
    },
    {
      question: t('faqs.audioPlayer.question'),
      answer: t('faqs.audioPlayer.answer'),
    },
    {
      question: t('faqs.projects.question'),
      answer: t('faqs.projects.answer'),
    },
    {
      question: t('faqs.vocabulary.question'),
      answer: t('faqs.vocabulary.answer'),
    },
    {
      question: t('faqs.subscriptionPlans.question'),
      answer: t('faqs.subscriptionPlans.answer'),
    },
    {
      question: t('faqs.searchPodcasts.question'),
      answer: t('faqs.searchPodcasts.answer'),
    },
    {
      question: t('faqs.playbackSpeed.question'),
      answer: t('faqs.playbackSpeed.answer'),
    },
    {
      question: t('faqs.dataSecurity.question'),
      answer: t('faqs.dataSecurity.answer'),
    },
    {
      question: t('faqs.cancelSubscription.question'),
      answer: t('faqs.cancelSubscription.answer'),
    },
  ];

  return (
    <>
      <SEO 
        title={t('title')}
        description={t('seoDescription')}
        keywords={t('seoKeywords')}
      />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 8,
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" textAlign="center" mb={2}>
            {t('title')}
          </Typography>
          <Typography variant="h6" textAlign="center" mb={6} sx={{ opacity: 0.9 }}>
            {t('subtitle')}
          </Typography>

          <Box sx={{ mb: 4 }}>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                sx={{
                  mb: 2,
                  bgcolor: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(10px)',
                  color: 'white',
                  '&:before': { display: 'none' },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                  sx={{
                    '& .MuiAccordionSummary-content': {
                      my: 2,
                    },
                  }}
                >
                  <Typography variant="h6" fontWeight="500">
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ opacity: 0.9 }}>
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>

          <Box 
            textAlign="center" 
            mt={6}
            sx={{
              bgcolor: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(10px)',
              borderRadius: 2,
              p: 3,
            }}
          >
            <Typography variant="body1" sx={{ opacity: 0.9 }}>
              {t('contactInfo')}{' '}
              <Typography
                component="a"
                href={`mailto:${t('supportEmail')}`}
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                  '&:hover': { opacity: 0.8 },
                }}
              >
                {t('supportEmail')}
              </Typography>
            </Typography>
          </Box>

          <Box textAlign="center" mt={6}>
            <Button
              component={Link}
              to={ROUTES.HOME}
              variant="contained"
              size="large"
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                '&:hover': { bgcolor: 'grey.100' },
                px: 4,
                py: 1.5,
                mr: 2,
              }}
            >
              {t('backToHome')}
            </Button>
            <Button
              component={Link}
              to={ROUTES.REGISTER}
              variant="outlined"
              size="large"
              sx={{
                borderColor: 'white',
                color: 'white',
                '&:hover': { borderColor: 'grey.100', bgcolor: 'rgba(255,255,255,0.1)' },
                px: 4,
                py: 1.5,
              }}
            >
              {t('getStarted')}
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};
